import React, { Component } from 'react';
import T from 'prop-types';
// hoc
import onClickOutside from 'react-onclickoutside';
import withSizes from 'react-sizes';
import { compose } from 'redux';
// components
import Icon from '../../../components/Icon/Icon';
import Calendar from '../../../components/Calendar/Calendar';
// styles
import Style from 'style-it';
import styles from './RecoveryCalendar.mod.css';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

class RecoveryCalendar extends Component {
  state = {
    isOpen: false
  };

  toggleCalendar = () => {
    this.setState(previousState => ({ isOpen: !previousState.isOpen }));
  };

  handleClickOutside = () => {
    const { isOpen } = this.state;
    isOpen && this.toggleCalendar();
  };

  render() {
    const { className, color, events } = this.props;
    const { isOpen } = this.state;

    return (
      <div className={cx('calendar-container', className)}>
        <Style>
          {`button { background: ${color}}`}
          <div>
            <button
              onClick={this.toggleCalendar}
              className={cx('title-button')}
            >
              <Icon type="calendar" className={cx('calendar-icon', 'mr-10')} />
              <span className="title">
                <strong>My calendar</strong>
              </span>
              <Icon
                type="chevron-up"
                className={cx('chevron', { rotated: !isOpen })}
              />
            </button>
          </div>
        </Style>
        <div
          className={cx('my-calendar', {
            hidden: !isOpen,
            fadeIn: isOpen
          })}
        >
          <Icon
            type="close"
            className={cx('closeButton')}
            onClick={this.toggleCalendar}
          />
          <Calendar events={events} color={color} />
        </div>
        <div
          onClick={this.toggleCalendar}
          className={cx('overlay', { isOpen })}
        />
      </div>
    );
  }
}

RecoveryCalendar.propTypes = {
  color: T.string.isRequired,
  className: T.string
};

const enhance = compose(
  withSizes(({ width }) => ({
    isMobile: width <= 420
  })),
  onClickOutside
);

export default enhance(RecoveryCalendar);



// WEBPACK FOOTER //
// ./src/containers/RecoveryPlan/components/RecoveryCalendar.jsx